export const handleLang = (lng) => {
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  document.body.className = lng === "ar" ? "rtl-body" : "ltr-body";
};

export const formatNumber = (value) => {
  if (value === null || value === undefined) return "0";
  const num = parseFloat(value);
  if (isNaN(num)) return "0";
  return Math.round(num).toString();
};

export const formatCurrency = (value, currency = "€") => {
  if (value === null || value === undefined) return `0 ${currency}`;
  const num = parseFloat(value);
  if (isNaN(num)) return `0 ${currency}`;
  return `${Math.round(num).toString()} ${currency}`;
};

// في src/utils/helpers.js
export const parseCoordinates = (input) => {
  if (!input) return null;
  
  try {
    // ✅ الحالة 1: string "lat,lng"
    if (typeof input === "string") {
      const [lat, lng] = input.split(",").map((v) => parseFloat(v.trim()));
      return isNaN(lat) || isNaN(lng) ? null : [lat, lng];
    }
    
    // ✅ الحالة 2: array
    if (Array.isArray(input)) {
      // ✅ الحالة 2أ: array of arrays [[lat, lng]]
      if (input.length > 0 && Array.isArray(input[0])) {
        const inner = input[0];
        // [["lat,lng"]] - string داخل array
        if (inner.length === 1 && typeof inner[0] === "string") {
          const [lat, lng] = inner[0].split(",").map((v) => parseFloat(v.trim()));
          return isNaN(lat) || isNaN(lng) ? null : [lat, lng];
        }
        // [[lat, lng]] - array داخل array
        if (inner.length === 2) {
          const [lat, lng] = inner.map(Number);
          return isNaN(lat) || isNaN(lng) ? null : [lat, lng];
        }
      }
      
      // ✅ الحالة 2ب: ["lat,lng"] - string داخل array مسطح
      if (input.length === 1 && typeof input[0] === "string") {
        const [lat, lng] = input[0].split(",").map((v) => parseFloat(v.trim()));
        return isNaN(lat) || isNaN(lng) ? null : [lat, lng];
      }
      
      // ✅ الحالة 2ج: [lat, lng] - array مباشر
      if (input.length === 2) {
        const [lat, lng] = input.map(Number);
        return isNaN(lat) || isNaN(lng) ? null : [lat, lng];
      }
    }
    
    // ✅ الحالة 3: object { lat, lng } أو { lat, lon }
    if (typeof input === "object" && input !== null) {
      const lat = Number(input.lat ?? input.latitude);
      const lng = Number(input.lng ?? input.lon ?? input.longitude);
      return isNaN(lat) || isNaN(lng) ? null : [lat, lng];
    }
  } catch (e) {
    console.warn("Error parsing coordinates:", e);
  }
  
  return null;
};

export const formatGermanDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};

export const formatDisplayDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};

/**
 * Senior Developer Grade Privacy Masking Helper.
 * Detects phone numbers of at least 8 digits and masks everything after the first 6 digits
 * while preserving formatting (spaces, dashes, parentheses).
 * Safe against small numbers, years, postcodes, and weights.
 */
export const maskPhoneNumbers = (text) => {
  if (!text || typeof text !== "string") return text;

  return text.replace(/(?:\+?[\d\s() -]{8,20}\d)/g, (match) => {
    const digits = match.replace(/\D/g, "");
    if (digits.length < 8) {
      return match;
    }

    let digitCount = 0;
    let result = "";
    for (let char of match) {
      if (/\d/.test(char)) {
        digitCount++;
        if (digitCount > 6) {
          result += "*";
          continue;
        }
      }
      result += char;
    }
    return result;
  });
};
